var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createMuiTheme } from "@material-ui/core/styles";
import { baseThemeOptions, createOverrides } from "../_base";
// See https://material-ui.com/customization/default-theme/ for avaliable options
var baseDaisyTheme = createMuiTheme(__assign(__assign({}, baseThemeOptions), { 
    // add Daisy specific theme options here
    palette: {
        primary: {
            main: "#022f6b",
            contrastText: "#fff"
        },
        secondary: {
            main: "#f29400"
        },
        info: {
            main: "#022f6b"
        },
        error: {
            main: "#a30115"
        },
        warning: {
            main: "#f29400"
        },
        success: {
            main: "#50b063",
            contrastText: "#fff"
        },
        background: {
            default: "#f1f1f1"
        },
        grey: {
            50: "#f8f7f9",
            100: "#e9e9ec",
            500: "#524b65",
            600: "#333333",
            800: "#140f1e" // neutralAbyss
        }
    } }) // TODO: Fix typing error
);
// JSS styling overrides
var overrides = __assign({}, createOverrides(baseDaisyTheme)
// add Daisy specific overrides here
);
var daisyTheme = createMuiTheme(__assign(__assign({}, baseDaisyTheme), { overrides: overrides }));
export { daisyTheme };
//# sourceMappingURL=index.js.map